import LegalPage from '@/components/legal/LegalPage';
import { BETA_AGREEMENT_TITLE, BETA_AGREEMENT_LAST_UPDATED, BETA_AGREEMENT_CONTENT } from '@/legal/beta_agreement';

const BetaAgreement = () => (
  <LegalPage
    title={BETA_AGREEMENT_TITLE}
    lastUpdated={BETA_AGREEMENT_LAST_UPDATED}
    content={BETA_AGREEMENT_CONTENT}
  />
);

export default BetaAgreement;
